<template>
  <div>
    <v-card>
      <div style="margin-left: 10px; margin-right: 10px">
        <div
          style="
            font-size: 18px;
            margin-left: 1rem;
            margin-right: 1rem;
            color: #444444;
            cursor: default;
            margin-top: -1rem;
          "
        ></div>
        <v-card-text>
          <div>
            <v-card elevation="10" style="padding: 2%; margin-top: 1%">
              <div>
                <v-row cols="12" xs="12" sm="12" md="12" justify="center">
                  <v-icon @click="BackToMainMenu()" size="45"
                    >mdi-arrow-left-bold-circle-outline</v-icon
                  >&nbsp;
                  <p
                    style="
                      text-align: center;
                      font-size: 22px;
                      color: #14223c;
                      padding-top: 1rem;
                    "
                  >
                    {{ $t("message.PreRegister") }}
                  </p>
                </v-row>
                <v-row>
                  <v-col cols="12" md="12">
                    <v-card flat>
                      <v-card-text>
                        <v-row cols="12" md="12" justify="center" dense>
                          <v-col cols="12" md="3">
                            <v-autocomplete
                              :items="InvitationList"
                              item-text="personName"
                              clearable
                              item-value="personId"
                              :label="$t('message.InvitationName')"
                              v-model="InvitationID"
                              dense
                              outlined
                              prepend-inner-icon="mdi-account"
                            ></v-autocomplete>
                          </v-col>
                        </v-row>
                        <v-row cols="12" md="12" justify="center" dense>
                          <v-col cols="12" md="3">
                            <v-text-field
                              :placeholder="$t('message.GuestInviteName')"
                              :label="$t('message.GuestInviteName')"
                              v-model="VisitorName"
                              type="text"
                              outlined
                              dense
                              prepend-inner-icon="mdi-account"
                            />
                          </v-col>
                          <v-col cols="12" md="3">
                            <v-text-field
                              :placeholder="$t('message.Email')"
                              :label="$t('message.Email')"
                              type="text"
                              v-model="VisitorEmail"
                              outlined
                              dense
                              prepend-inner-icon="mdi-email"
                            />
                          </v-col>
                        </v-row>
                        <v-row cols="12" md="12" justify="center" dense>
                          <v-col cols="12" md="3">
                            <v-menu
                              v-model="menuStartDate"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              transition="scale-transition"
                              offset-y
                              min-width="auto"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-model="StartDateDisplay"
                                  :label="$t('message.StartDate')"
                                  prepend-inner-icon="mdi-calendar"
                                  outlined
                                  dense
                                  readonly
                                  v-bind="attrs"
                                  v-on="on"
                                  clearable
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                v-model="StartDate"
                                :min="today"
                                @change="menuStartDate = false"
                              ></v-date-picker>
                            </v-menu>
                          </v-col>
                          <v-col cols="12" md="3">
                            <v-menu
                              ref="menuStartTime"
                              v-model="menuStartTime"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              :return-value.sync="StartTime"
                              transition="scale-transition"
                              offset-y
                              max-width="290px"
                              min-width="290px"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-model="StartTime"
                                  :label="$t('message.StartTime')"
                                  prepend-inner-icon="mdi-clock-time-four-outline"
                                  readonly
                                  v-bind="attrs"
                                  outlined
                                  dense
                                  v-on="on"
                                ></v-text-field>
                              </template>
                              <v-time-picker
                                v-if="menuStartTime"
                                v-model="StartTime"
                                full-width
                                format="24hr"
                                @click:hour="onSelectHour"
                                @click:minute="
                                  $refs.menuStartTime.save(StartTime)
                                "
                                :allowed-hours="allowedHours"
                                :allowed-minutes="allowedMinutes"
                              />
                            </v-menu>
                          </v-col>
                        </v-row>
                        <v-row cols="12" md="12" justify="center" dense>
                          <v-col cols="12" md="3">
                            <v-menu
                              v-model="menuEndDate"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              transition="scale-transition"
                              offset-y
                              min-width="auto"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-model="EndDateDisplay"
                                  :label="$t('message.EndDate')"
                                  prepend-inner-icon="mdi-calendar"
                                  outlined
                                  dense
                                  readonly
                                  v-bind="attrs"
                                  v-on="on"
                                  clearable
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                v-model="EndDate"
                                :min="today"
                                @change="menuEndDate = false"
                              ></v-date-picker>
                            </v-menu>
                          </v-col>
                          <v-col cols="12" md="3">
                            <v-menu
                              ref="menuEndTime"
                              v-model="menuEndTime"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              :return-value.sync="EndTime"
                              transition="scale-transition"
                              offset-y
                              max-width="290px"
                              min-width="290px"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-model="EndTime"
                                  :label="$t('message.EndTime')"
                                  prepend-inner-icon="mdi-clock-time-four-outline"
                                  readonly
                                  v-bind="attrs"
                                  outlined
                                  dense
                                  v-on="on"
                                ></v-text-field>
                              </template>
                              <v-time-picker
                                v-if="menuEndTime"
                                v-model="EndTime"
                                full-width
                                format="24hr"
                                @click:hour="onSelectEndHour"
                                @click:minute="$refs.menuEndTime.save(EndTime)"
                                :allowed-hours="allowedEndHours"
                                :allowed-minutes="allowedEndMinutes"
                              />
                            </v-menu>
                          </v-col>
                        </v-row>
                        <v-row cols="12" md="12" justify="center" dense>
                          <v-col cols="12" md="6">
                            <v-textarea
                              v-model="Remark"
                              :label="$t('message.Remark')"
                              outlined
                              prepend-inner-icon="mdi-calendar-text"
                            ></v-textarea>
                          </v-col>
                        </v-row>
                        <v-row
                          cols="12"
                          xs="12"
                          sm="12"
                          md="12"
                          justify="center"
                        >
                          <v-col cols="12" md="4" align="center">
                            <v-btn
                              style="color: white"
                              height="40"
                              width="150"
                              color="green"
                              @click="inviteVisitor()"
                            >
                              {{ $t("message.Submit") }}
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </div>
            </v-card>
          </div>
        </v-card-text>
      </div>
    </v-card>

    <v-dialog v-model="LoadingDialog" persistent width="auto">
      <v-card
        class="pa-6 d-flex flex-column align-center justify-center"
        elevation="8"
        rounded="xl"
      >
        <v-progress-circular
          indeterminate
          color="indigo"
          size="70"
          width="6"
        ></v-progress-circular>
        <span class="mt-4 text-subtitle-1 font-weight-medium"
          >Loading, please wait...</span
        >
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from "axios";
import enurl from "@/api/environment";
import Swal from "sweetalert2/dist/sweetalert2.js";

export default {
  name: "PreRegister",
  data() {
    return {
      url: enurl.apiUrl,
      LoadingDialog: false,
      QRvalue: "",
      QRsize: 250,
      Username: this.$cookies.get("Username"),
      EmailList: [],
      TenantList: [],

      InvitationList: [],
      InvitationID: null,
      VisitorEmail: "",
      StartDate: "",
      EndDate: "",
      menuStartDate: false,
      menuEndDate: false,
      StartTime: null,
      menuStartTime: false,
      EndTime: null,
      menuEndTime: false,
      VisitorName: "",
      Remark: "",
      today: new Date().toISOString().substr(0, 10),
    };
  },

  computed: {
    StartDateDisplay() {
      if (!this.StartDate) return "";
      let [year, month, day] = this.StartDate.split("-");
      return `${day}-${month}-${year}`;
    },
    EndDateDisplay() {
      if (!this.EndDate) return "";
      let [year, month, day] = this.EndDate.split("-");
      return `${day}-${month}-${year}`;
    },
  },

  async mounted() {
    let self = this;
    await self.getDataPersonListFromTenantID();
  },

  methods: {
    allowedHours(hour) {
      const now = new Date();
      const currentHour = now.getHours();
      if (this.StartDate !== this.today) {
        return true;
      }
      return hour >= currentHour;
    },

    onSelectHour(h) {
      this.StartTime = `${h.toString().padStart(2, "0")}:00`;
    },

    allowedMinutes(minute) {
      if (!this.StartTime) return true;
      const now = new Date();
      const currentHour = now.getHours();
      const currentMinute = now.getMinutes();
      const selectedHour = parseInt(this.StartTime.split(":")[0], 10);
      if (this.StartDate !== this.today) {
        return true;
      }
      if (selectedHour === currentHour) {
        return minute > currentMinute;
      }
      return true;
    },

    allowedEndHours(hour) {
      const now = new Date();
      const currentHour = now.getHours();
      const [startHour] = this.StartTime ? this.StartTime.split(":") : [null];
      if (this.EndDate !== this.today) {
        if (startHour !== null && hour < parseInt(startHour)) {
          return false;
        }
        return true;
      }
      if (hour < currentHour) {
        return false;
      }
      if (startHour !== null && hour < parseInt(startHour)) {
        return false;
      }
      return true;
    },

    onSelectEndHour(h) {
      this.EndTime = `${h.toString().padStart(2, "0")}:00`;
    },

    allowedEndMinutes(minute) {
      if (!this.EndTime) return true;
      const now = new Date();
      const currentHour = now.getHours();
      const currentMinute = now.getMinutes();
      const [startHour, startMinute] = this.StartTime
        ? this.StartTime.split(":").map(Number)
        : [null, null];

      const [selectedHour] = this.EndTime.split(":").map(Number);
      if (this.EndDate !== this.today) {
        if (selectedHour === startHour && minute <= startMinute) {
          return false;
        }
        if (selectedHour < startHour) {
          return false;
        }
        return true;
      }
      if (selectedHour === currentHour) {
        if (minute <= currentMinute) {
          return false;
        }
      }
      if (selectedHour === startHour) {
        if (minute <= startMinute) {
          return false;
        }
      }
      if (selectedHour < startHour) {
        return false;
      }
      return true;
    },

    async getDataPersonListFromTenantID() {
      let self = this;
      self.LoadingDialog = true;
      await axios
        .get(`${self.url}PreRegister/getDataPersonListFromTenantID`)
        .then(function (response) {
          if (response.data.status == 0) {
            self.InvitationList = response.data.data;
          }
        })
        .catch(function (error) {
          let message = "เกิดข้อผิดพลาด";
          if (error.response && error.response.data) {
            message = error.response.data.message || message;
          }
          Swal.fire({
            icon: "error",
            title: "Error...",
            width: 900,
            text: message,
          });
        })
        .finally(() => {
          self.LoadingDialog = false;
        });
    },

    inviteVisitor() {
      let self = this;
      if (
        self.InvitationID == null ||
        self.visitorName == "" ||
        self.VisitorEmail == "" ||
        self.StartDate == "" ||
        self.StartTime == "" ||
        self.EndDate == "" ||
        self.EndTime == ""
      ) {
        Swal.fire({
          icon: "warning",
          width: 600,
          text: "กรุณากรอกข้อมูลผู้มาติดต่อให้ครบถ้วน !",
        });
      } else if (self.EndTime <= self.StartTime) {
        Swal.fire({
          icon: "warning",
          width: 600,
          text: "วันที่และเวลาสิ้นสุดต้องไม่อยู่ก่อนวันที่และเวลาเริ่มต้น !",
        });
      } else {
        self.LoadingDialog = true;
        let temp = {
          invitationID: self.InvitationID,
          visitorName: self.VisitorName,
          visitorEmail: self.VisitorEmail,
          startDate: self.StartDate,
          endDate: self.EndDate,
          startTime: self.StartTime,
          endTime: self.EndTime,
          locationID: self.Floor,
          remark: self.Remark,
        };
        axios
          .post(`${self.url}PreRegister/invitePreRegister`, temp)
          .then(function (response) {
            if (response.data.status == 0) {
              Swal.fire({
                icon: "success",
                title: "Success",
                showConfirmButton: false,
                timer: 1500,
              });
              self.ClearDataInput();
            }
          })
          .catch(function (error) {
            let message = "เกิดข้อผิดพลาด";
            if (error.response && error.response.data) {
              message = error.response.data.message || message;
            }
            Swal.fire({
              icon: "error",
              title: "Error...",
              width: 900,
              text: message,
            });
          })
          .finally(() => {
            self.LoadingDialog = false;
          });
      }
    },

    ClearDataInput() {
      let self = this;
      self.InvitationID = null;
      self.VisitorName = "";
      self.VisitorEmail = "";
      self.StartDate = "";
      self.EndDate = "";
      self.StartTime = null;
      self.EndTime = null;
      self.Remark = "";
    },

    BackToMainMenu() {
      let self = this;
      self.$router.push("/MainMenu");
    },
  },
};
</script>
<style scoped>
</style>
    